import NotificationDetailComponent from 'src/components/features/superAdmin/notificationDetailComponent';

const DetailNotificationPage = () => <NotificationDetailComponent />;

export default DetailNotificationPage;
